import React from 'react';
import Draggable, { DraggableProps } from 'react-draggable';

/**
 * react-draggable's type definition treats many defaulted props as required.
 * This wrapper keeps the runtime behaviour identical while letting callers pass
 * only the props they actually need.
 */
type RelaxedDraggableProps = Partial<Omit<DraggableProps, 'children'>> & Pick<DraggableProps, 'children'>;

const defaultedProps: Partial<DraggableProps> = {
    allowAnyClick: false,
    allowMobileScroll: false,
    bounds: undefined,
    cancel: undefined,
    defaultClassName: 'react-draggable',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultClassNameDragging: 'react-draggable-dragging',
    enableUserSelectHack: true,
    grid: undefined,
    offsetParent: undefined,
    position: undefined,
    positionOffset: undefined,
    scale: 1,
};

export const RelaxedDraggable: React.FC<RelaxedDraggableProps> = ({ children, ...rest }) => {
    const mergedProps = {
        ...defaultedProps,
        ...rest,
    } as DraggableProps;

    return <Draggable {...mergedProps}>{children}</Draggable>;
};
